<template>
  <div>
    <div class="z-title z-title--small" v-if="title">
      {{ title }}
    </div>

    <p class="z-text spacer-bottom-l" v-if="description">
      {{ description }}
    </p>

    <list-loader v-if="loading" />

    <template v-else-if="bills.length > 0">
      <template v-for="year in years" class="spacer-bottom-xl">
        <div class="spacer-top-l spacer-bottom-m" :key="year">
          <span class="z-badge-text">Mensalidades de {{ year }}</span>
        </div>

        <bill
          v-for="bill in billsByYear[year]"
          :key="bill.id"
          :bill="bill"
        />
      </template>
    </template>

    <empty-bills v-else />
  </div>
</template>

<script>
import EmptyBills from 'components/empty-bills';
import ListLoader from 'content-loaders/list-loader';
import groupBy from 'lodash/groupBy';
import Bill from './bill';

export default {
  components: {
    Bill,
    EmptyBills,
    ListLoader,
  },
  props: {
    bills: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
  computed: {
    billsByYear() {
      return groupBy(this.bills, (bill) => bill.bill_year);
    },
    years() {
      return Object.keys(this.billsByYear).sort();
    },
  },
};
</script>
